import { Action, EAction } from './action';

const tenantNpsActions = [
  ...EAction.all,
  'open',
  'close',
  'export',
  'viewComments',
] as const satisfies Action[];

const companyNpsActions = [
  ...EAction.read,
  'export',
  'viewComments',
] as const satisfies Action[];

export const companyRoles = {
  documents: EAction.read,
  document_categories: EAction.read,
  document_requests: EAction.all,
  busline_schedules: EAction.read,
  departments: EAction.read,
  company_memberships: EAction.all,
  company: ['viewDetails'],
  nps: companyNpsActions,
} as const satisfies Record<string, Action[]>;

export const tenantRoles = {
  all: ['manage'],
  documents: EAction.all,
  document_categories: EAction.all,
  document_requests: EAction.all,
  companies: EAction.all,
  buslines: EAction.all,
  busline_schedules: ['list', 'viewDetails', 'update'],
  departments: EAction.all,
  roles: EAction.all,
  memberships: [...EAction.all, 'changePassword'],
  actings: [...EAction.all, 'abort'],
  checklists: EAction.all,
  tenants: EAction.all,
  fleets: ['list', 'create', 'update', 'delete'],
  document_permissions: ['update'],
  company_memberships: ['list', 'create', 'update', 'changePassword'],
  company: ['viewDetails'],
  nps: tenantNpsActions,
} as const satisfies Record<string, Action[]>;

// Define types for role abilities and application abilities
export type RoleAbilities<Roles extends Record<string, Action[]>> = {
  [K in keyof Roles]: Roles[K] extends Action[] ? [Roles[K][number], K] : never;
};

export type AppAbilities<Roles extends Record<string, Action[]>> =
  RoleAbilities<Roles>[keyof RoleAbilities<Roles>];
